"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("@linaria/react");
var _intents = _interopRequireDefault(require("@ux/intents"));
var _core = require("@linaria/core");
"tu5xkrf";
const intents = new _intents.default();
const TestimonialCardStyle = /*#__PURE__*/(0, _react.styled)("div")({
  name: "TestimonialCardStyle",
  class: "tw61e35"
});
var _default = exports.default = TestimonialCardStyle;